import { all } from 'redux-saga/effects';

// Importando meus sagas
import auth from './auth/saga';
import user from './user/saga';

export default function* rootSaga() {
  return yield all([auth, user]);
}
